import { Dispatch, FC, SetStateAction } from 'react';

import { Card } from '@/components/atoms';
import { CardContent } from '@/components/atoms/Card/Card';
import { SurveyOverviewBuilderQuestion } from '@/pages/Surveys/SurveysOverviewBuilder/types';
import { cn } from '@/utils/tailwind';

import { Stepper } from '../Stepper/Stepper';

import { SurveyQuestionChoiceStep } from './components/SurveyQuestionChoiceStep';
import { SurveyQuestionScaleStep } from './components/SurveyQuestionScaleStep';
import { SurveyQuestionTextStep } from './components/SurveyQuestionTextStep';

export type SurveyQuestionStepperData = {
  answer: string;
  scale: number;
  selected: string[];
};

export type SurveyQuestionSetStepperData = Dispatch<SetStateAction<SurveyQuestionStepperData>>;

type SurveyQuestionStepperProps = {
  currentStep: number;
  className?: string;
  stepperData: SurveyQuestionStepperData;
  questions: SurveyOverviewBuilderQuestion[];
  setStepperData: SurveyQuestionSetStepperData;
};

export const SurveyQuestionStepper: FC<SurveyQuestionStepperProps> = ({
  stepperData,
  currentStep,
  className,
  questions,
  setStepperData,
}) => {
  const renderStep = (question: SurveyOverviewBuilderQuestion, index: number) => {
    switch (question.type) {
      case 'text':
        return SurveyQuestionTextStep(
          stepperData,
          setStepperData,
          question,
          index,
          questions.length
        );
      case 'scale':
        return SurveyQuestionScaleStep(
          stepperData,
          setStepperData,
          question,
          index,
          questions.length
        );
      case 'choice':
        return SurveyQuestionChoiceStep(
          stepperData,
          setStepperData,
          question,
          index,
          questions.length
        );
    }
  };

  const steps = questions.map((q, idx) => renderStep(q, idx));

  return (
    <Card
      className={cn(
        'shadow-survey-card-question rounded-[16px] px-6 py-5 max-w-[600px] w-full',
        className
      )}
    >
      <CardContent className="w-full">
        <Stepper currentStep={currentStep} steps={steps} />
      </CardContent>
    </Card>
  );
};
